import { render } from "./Radar.vue?vue&type=template&id=4667ab9c&scoped=true"
import script from "./Radar.vue?vue&type=script&lang=js"
export * from "./Radar.vue?vue&type=script&lang=js"

import "./Radar.vue?vue&type=style&index=0&id=4667ab9c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4667ab9c"]])

export default __exports__